/*-----------------------------------------------------------------------------/
/ TODO:
/-----------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------/
/ Custom Liquid
/-----------------------------------------------------------------------------*/

// cart-free-shipping-bar.liquid
//    Added BYOC message in free shipping bar

// section-custom.liquid
//   Added a Project 7 Archive anchor tag. This allows navigation from the archive beer page back to the project 7 landing page archive section

//cart-drawer.liquid
//   To remove the free shipping bar for products with keywords
//   To hide the free shipping bar by using keywords in the product title
//   Adds BYOC message to drawer

//main-cart.liquid
//  To remove the free shipping bar for products with keywords
//  Section added to display the number of items added from byoc collection

// cart-details.liquid
//  Over 18 verification before proceeding to the checkout
//  Hides ShopifyPay and GooglePay buttons. This was bypassing the T&C's and Age Verification checkboxes. ShopifyPay and GooglePay can be accessed in the checkout

//product-card.liquid
//  added to remove quick shop from the Project 7 Archive
//  added to remove Sold Out Label from the Project 7 Archive
//  added to remove price Label from the Project 7 Archive
//  Removes Quickshop icon for collections, pages or products
//  Added to put custom stylised text under products or collections. For example; Project 7 under each Project 7 product.

//quick-shop.liquid
// To remove the 'Shipping calculated as checkout' statement from quick shop

//product-price.liquid
// Removes 'Shipping calculated at Checkout' from products

//section-product-recommendations.liquid
// Remove the quick add button from recommendations, to prevents products that require a booking date from being added directly to the cart without selecting a date

//section-multi-column-images.liquid
//  Added to remove columns without images or videos. This is for the beer pages in the Trade section. The page template has every packaging format, but only displays the formats with images
// Added a snippet to make the column blocks visiable from a datetime and invisible at a datetime

//pdp-blocks.liquid
// Added line to remove free shipping bar, price and quantity selector from collections with tag. Currently used for keg and cask hire
// Removes ABV and IBU's for non applicable products

//cart-item.liquid
// Hide the remove and quantity buttons for products specified titles.

//theme.liquid
// Added Microsoft Clarity code snippet
// Added Bing Webmaster code snippet

//gift-card-template.liquid
//  Added custom image for online gift cards

// tabology-booking-widget.liquid
//  Added entire file to create a tabology booking widget

// section-events.liquid
// Commented out original code and added a line to allow customised link arrows
// Commented out original code for description section and added new code to hide the section behind a dropdown arrow
// Added a snippet to make the event blocks visiable from a datetime and invisible at a datetime

// section-countdown-timer.liquid
// Added a snippet to make the section visiable from a datetime and invisible at a datetime

// section-announcement-bar.liquid
// Added a snippet to make the section and annoucement blocks visiable from a datetime and invisible at a datetime

// section-multi-column-icons.liquid
// Added a snippet to make the column blocks visiable from a datetime and invisible at a datetime

// section-image-slideshow.liquid
// Added a snippet to make the section visiable from a datetime and invisible at a datetime

// section-collection.liquid
// Added a snippet to make the section visiable from a datetime and invisible at a datetime

// section-image-grid.liquid
// Added a snippet to make the section visiable from a datetime and invisible at a datetime
// Added a snippet to make the text blocks visiable from a datetime and invisible at a datetime

// waitlist-widget.liquid
// Custom widget for event waitlists. Linked to Power Automate Webhook for notifications and spreadsheet updates

/*-----------------------------------------------------------------------------/
/ Custom CSS
/-----------------------------------------------------------------------------*/

// component-cart.css
//   Added pointer-events: none; to allow the link under the free-shipping-bar__animation to be clickable
//   Changed font size of .cart-item__qty quantity-input input[type=number], from 0.865rem to 0.85rem, to fit better in the cart quantity box

// section-announcement-bar.css
//   Centre announcement popup text

//global.css
//  Added to centre the project 7 archive title text
//  myColourStrip added
//  Code added to centre the products in a featured collection product grid
//  CSS added for _byoc checkout message
//  Spoiler warning CSS

//base.css
// Changed the mono button colour to the Natural Selection Brewing 2025 colour scheme
// Events shown in a row of 3 in desktop screen instead of 2
// Changes colour of blog cards
// Removes gap above the Shop Shortcut Navigation. To add more pages, find the page ID add in ':not(#NEW-PAGE)' before '.main'
// Added to scroll anchor tags smoothly and slightly above the tag. Instructions below:

// component-blog.css
// Added custom setting to have blog posts sit within a card

// section-events.css
// Moved event date to bottom of image
// Added dropdown arrow to hide the long description in mobile view

// component-media-gallery.css
// Changed media image object-fit from cover to contain so that it fits in the div

/*-----------------------------------------------------------------------------/
/ Custom Javascript
/-----------------------------------------------------------------------------*/

//cart-components.js
// Updates the BYOC message if the quantity of BYOC products are changed

//cart-recommendations.js
//  Removes a product title from the cart recommendations. Currently used for _deposit, keg, cask, tour, ticket and brew it yourself. The cart recommendations bypass BTA

/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

//SBCUSTOM: Addeed to open links in a new tab
const links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

//SBCUSTOM: Faded blog border in and out
document.addEventListener("DOMContentLoaded", function () {
  const blogCards = document.querySelectorAll(".blog");

  blogCards.forEach((blog) => {
    const tagLink = blog.querySelector(".blog__meta-tags__link");
    if (tagLink) {
      const tagText = tagLink.textContent
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      blog.classList.add(`blog--tag-${tagText}`);
    } else {
      blog.classList.add("blog--tag-default");
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const ratio = entry.intersectionRatio;

        if (ratio >= 0.7) {
          entry.target.classList.add("blog--in-view");
        } else if (ratio < 0.7) {
          entry.target.classList.remove("blog--in-view");
        }
      });
    },
    {
      threshold: Array.from({ length: 101 }, (_, i) => i / 100),
    }
  );

  blogCards.forEach((blog) => observer.observe(blog));
});

/* Hide event section */
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('.event__toggle').forEach(button => {
  button.addEventListener('click', () => {
    const desc = button.closest('.event').querySelector('.event__desc');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', !isExpanded);
    desc.classList.toggle('active');
  });
});
});


/* --- Beer Spoiler Button Action --- */
document.addEventListener('DOMContentLoaded', function () {
  var button = document.getElementById('toggle-button');
  if (button) {
    button.addEventListener('click', toggleBeers);
    button.style.cursor = 'pointer'; // Makes the cursor change on hover
  }
});
function toggleBeers() {
  var beerList = document.getElementById('beer-list');
  var button = document.getElementById('toggle-button');
  if (beerList.classList.contains('revealed')) {
    beerList.classList.remove('revealed');
    button.textContent = 'Reveal the Beers';
  } else {
    beerList.classList.add('revealed');
    button.textContent = 'Hide the Beers';
  }
}

/*-----------------------------------------------------------------------------*/
/* UPDATE TESTS */
/*-----------------------------------------------------------------------------*/
// BYOC MESSAGE
// Does the BYOC message add the the cart drawer and cart *** PASS 2026-02-13 RW ***
// Is the 'Build Your Own Case collection!' link clickable in the cart drawer *** PASS 2026-02-13 RW ***
// Is the BYOC message visable in the cart with a keg or cask hire product *** PASS 2026-02-13 RW ***
// Does the number of items update automatically in the cart *** PASS 2026-02-13 RW *** 

// MERCH FOOD ABV AND IBU'S
// Are the ABV and IBU's removed from merchandise food items *** PASS 2026-02-13 RW ***

// ANNOUNCEMENT BAR POP UPS
// On announement bar pop ups, is the text centred in the card  *** PASS 2026-02-13 RW ***

// PROJECT 7 ARCHIVE
// Are the prices, quick shop and sold out labels removed from Project 7 archive products, don't forget to check mobile view *** PASS 2026-02-13 RW ***
// Does the 'Back to the archive' button take you to the correct place *** PASS 22026-02-13 RW ***

// FREE SHIPPING BAR
// Is the free shipping bar removed from keg/cask hire products, tours and CBK *** PASS 2026-02-13 RW ***

// CART
//  T&C'S Are you prevented from checking out with ticking the T&C's field and the Over 18 field *** PASS 2026-02-13RW ***
// BTA  products are not recommended *** PASS 2026-02-13 RW ***

// PRODUCT CARDS
//  Is the message 'Shipping calculated at checkout' removed from quickshop cards? *** PASS 2026-02-13 RW ***
// Are the product ranges added under the products name. For example, Project 7 *** PASS 2026-02-13 RW ***

// MIXED CASES
// In each mixed case, are the contents of the mixed case displayed as cards and are the styled *** PASS 2026-02-13 RW ***

// PRODUCT GRID
// Are products centred in the product grid *** PASS 2026-02-13 RW ***

// MENU LINKS
// The food menus open in a new tab and don't navigate away from our site *** PASS 2026-02-13 RW ***

// BLOG POSTS
// Blog cards are highlighted as you scroll past them *** PASS 2025-10-13 RW ***